export default __webpack_public_path__ + "static/media/TARUN MAKHIJA.edd59b97.jpg";